// Chrome-stripped wrapper for the iOS WebView embed routes (PRD §15.5 / §15.6).
//
// The native iOS shell owns the top bar, sidebar, and background — the
// embed must NOT paint over the system color or duplicate navigation. We
// therefore:
//   - render no `<Sidebar>` / `<HeaderWithNavigation>` / `<Footer>`
//   - use a transparent background
//   - ship a global CSS rule ensuring `<input>` / `<textarea>` font-size
//     is at least 16px (iOS WKWebView auto-zooms below that — fails PRD
//     iOS acceptance criterion #11)

import React from "react";
import { Box } from "@chakra-ui/react";

const EMBED_INPUT_STYLE_ID = "ethosphere-embed-input-zoom-guard";

const ensureInputStyleInjected = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(EMBED_INPUT_STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = EMBED_INPUT_STYLE_ID;
  // Anchor the rule under the embed container so we don't leak it into
  // any other (non-embed) parts of the tree if the bundle is shared.
  style.textContent = `
[data-ethosphere-embed="true"] input,
[data-ethosphere-embed="true"] textarea,
[data-ethosphere-embed="true"] select {
  font-size: 16px;
}
`;
  document.head.appendChild(style);
};

export default function EmbedLayout({ children }) {
  React.useEffect(() => {
    ensureInputStyleInjected();
  }, []);

  return (
    <Box
      data-ethosphere-embed="true"
      data-testid="embed-layout"
      bg="transparent"
      minH="100vh"
      px={0}
      py={0}
      m={0}
    >
      {children}
    </Box>
  );
}
